export default {
  isAuthenticated: (state) => state.authenticated,
  hasPermissions: (state) => state.hasLoadedPermissions,
  isSuperAdmin: (state) => state.isSuperAdmin,
  getUserId: (state) => state.user,
  getToken: (state) => state.token,
  getUserName: (state) => state.userName,
  getUserEmail: (state) => state.userEmail,
  getUserDateOfBirth: (state) => state.userDateOfBirth,
  getUserData: (state) => state.userData,
  getTokenExpiration: (state) => state.tokenExpiration,
  getIsLoginFromOldUI: (state) => state.isLoginFromOldUI,
  getRedirectUrl: (state) => state.redirectUrl,
  // getPauseAuth: (state) => state.pauseAuth,
  // getAuthError(state) {
  // 	var now = new Date();
  // 	if (Math.abs(now - state.authErrorTimer) > 60 * 1000) {
  // 		state.authError = "";
  // 		localStorage.setItem("authError", "");
  // 		state.authErrorTimer = null;
  // 		localStorage.setItem("authErrorTimer", null);
  // 	}
  // 	return state.authError;
  // },
  // getContext: (state) => state.context,
  // getLoginPopup: (state) => state.loginPopup,
  // getReturnUrl: (state) => state.returnUrl,
  // getLog: (state) => state.log,
  // getRefreshTimer: (state) => state.refreshTimer,
  // getTenantId: (state) => state.tenantId,
};
